module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('div', [_c('h4', {
    staticClass: "content-c2"
  }, [_vm._v(_vm._s(_vm.t_data.copyright))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "content-c3"
  }, [_vm._v(_vm._s(_vm.t_data.license))])])]), _vm._v(" "), _c('ul', {
    staticClass: "c4"
  }, [_c('div', [_c('li', {
    staticClass: "tel"
  }, [_c('a', {
    staticClass: "c5",
    attrs: {
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.t_data.phone))])]), _vm._v(" "), _c('li', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.t_data.time))])]), _vm._v(" "), _c('li', {
    staticClass: "online"
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b609a0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b609a0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/footerPage/components/plugins/footer/index.vue
// module id = 2637
// module chunks = 0